/**
 * Static-translations for ja. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const ja = {
  'anon.description_default': 'ゲストセッションを設定中…',
  'anon.heading_default': 'ゲストとして続ける',
  'anon.try_again': '再試行',
  'auth.back_to_login': 'ログインに戻る',
  'auth.check_email_message': '確認コードのメールをご確認ください。',
  'auth.check_email_title': 'メールをご確認ください',
  'auth.confirm_email_subtitle': 'メールに送信したコードを入力してアカウント作成を完了してください。',
  'auth.confirm_email_title': 'メールアドレスを確認',
  'auth.confirmation_code': '確認コード',
  'auth.continue_with_apple': 'Appleで続行',
  'auth.continue_with_facebook': 'Facebookで続ける',
  'auth.continue_with_github': 'GitHubで続ける',
  'auth.continue_with_google': 'Googleで続行',
  'auth.create_account': 'アカウント作成',
  'auth.default_subtitle': 'すべての機能にアクセスしてデータを同期するためにサインインしてください。',
  'auth.email': 'メールアドレス',
  'auth.email_already_registered': 'このメールアドレスは既に登録されています。下記からパスワード、または登録に使用したアカウントでサインインしてください。',
  'auth.email_exists': 'このメールアドレスのアカウントは既に存在します。',
  'auth.email_not_confirmed': '先にメールを確認してください。',
  'auth.forgot_password': 'パスワードをお忘れですか?',
  'auth.forgot_password_title': 'パスワードをお忘れですか?',
  'auth.forgot_subtitle': 'メールアドレスを入力すると、パスワードリセットリンクを送信します。',
  'auth.generic_error': 'エラーが発生しました',
  'auth.have_account': 'アカウントをお持ちですか?',
  'auth.hide_password': 'パスワードを非表示',
  'auth.identity_already_linked': 'このアカウントは既に登録されています。下記からサインインしてください。',
  'auth.invalid_credentials': 'メールアドレスまたはパスワードが正しくありません',
  'auth.invalid_otp': 'コードが無効か期限切れです。',
  'auth.last_used': '前回使用 · {email}',
  'auth.last_used_no_email': '前回使用',
  'auth.link_purchase_subheading': 'アクセスを保持するため、購入をアカウントに紐付けます。',
  'auth.log_in': 'ログイン',
  'auth.log_in_link': 'ログイン',
  'auth.login_continue_purchase': 'ログインして購入を続ける',
  'auth.network_error': 'ネットワークエラー。接続を確認してもう一度お試しください。',
  'auth.new_password_optional': '新しいパスワード (任意 — パスワードリセット時のみ)',
  'auth.no_account': 'アカウントをお持ちでないですか?',
  'auth.or': 'または',
  'auth.password': 'パスワード',
  'auth.passwords_mismatch': 'パスワードが一致しません',
  'auth.rate_limited': 'リクエストが多すぎます。後でもう一度お試しください。',
  'auth.repeat_password': 'パスワードを再入力',
  'auth.reset_link_valid': 'リンクの有効期間は1時間です。',
  'auth.reset_password_subtitle': 'メールに記載されたコードと新しいパスワードを入力してください。',
  'auth.reset_password_title': 'パスワードをリセット',
  'auth.reset_sent_message': 'そのメールが存在する場合、リセットコードが送信されました。',
  'auth.reset_sent_subtitle': 'パスワードリセットのリンクをメールで送信しました。メール内の指示に従ってください。',
  'auth.restore_purchases_heading': '購入を復元',
  'auth.restore_purchases_subheading': '購入を復元するためにサインインしてください。',
  'auth.send_reset': 'リセットメールを送信',
  'auth.service_unavailable': 'サービスが一時的に利用できません。しばらくしてからお試しください。',
  'auth.show_password': 'パスワードを表示',
  'auth.sign_out': 'サインアウト',
  'auth.sign_up': '新規登録',
  'auth.sign_up_link': '新規登録',
  'auth.signed_in': 'サインイン中',
  'auth.signin_failed': 'サインインに失敗しました',
  'auth.signup_failed': 'サインアップに失敗しました',
  'auth.verify': '確認',
  'auth.weak_password': 'パスワードが弱すぎます。',
  'auth.welcome': 'ようこそ!',
  'auth.welcome_signup': 'ようこそ!',
  'countdown.d': '日',
  'countdown.h': '時',
  'countdown.m': '分',
  'countdown.s': '秒',
  'cta.close': '閉じる',
  'cta.continue': '続ける',
  'cta.get_lifetime_access': '永久アクセスを取得',
  'cta.get_plan_daily': '日次プランを取得',
  'cta.get_plan_generic': '{interval}プランを取得',
  'cta.get_plan_monthly': '月次プランを取得',
  'cta.get_plan_weekly': '週次プランを取得',
  'cta.get_plan_yearly': '年次プランを取得',
  'cta.start_trial': '{days}日間の無料トライアルを開始',
  'modal.close_aria': '閉じる',
  'modal.continue': '続ける',
  'modal.error_generic': 'エラーが発生しました',
  'modal.loading': '読み込み中…',
  'modal.purchase_restored_subtitle': '準備完了 — お楽しみください！',
  'modal.purchase_restored_title': 'おかえりなさい',
  'modal.purchase_success_subtitle': '準備完了 — お楽しみください！',
  'modal.purchase_success_title': 'お支払いが完了しました',
  'modal.verifying_subscription': 'サブスクリプションを確認中…',
  'nav.back': '← 戻る',
  'nav.back_aria': '戻る',
  'offer.limited_time': '期間限定オファー',
  'payment.awaiting_subtitle': '自動的に支払いを検出します — または完了したら下のボタンを押してください。',
  'payment.awaiting_title': '新しいタブで支払いを完了してください',
  'payment.checking': '確認中…',
  'payment.ive_paid': '支払いました',
  'payment.open_checkout_again': 'もう一度チェックアウトを開く',
  'payment.open_checkout_button': 'チェックアウトを開く',
  'payment.popup_blocked_message': 'ブラウザがチェックアウトタブをブロックしました。下のボタンで開いてください。',
  'payment.popup_blocked_title': '続行するにはポップアップを許可してください',
  'payment.popup_help_text': 'チェックアウト画面が開かなかった、またはブロックされましたか？ここをクリックして再度開いてください。',
  'payment.still_processing': '支払いはまだ処理中です。少し時間をおいて再度お試しください。',
  'payment.tab_closed_retry': 'タブを閉じた？もう一度試す',
  'pricing.free_trial_days': '{days}日間無料トライアル',
  'pricing.included_per': '{interval}に含まれる:',
  'pricing.interval.day': '日',
  'pricing.interval.lifetime_short': '永久',
  'pricing.interval.month': '月',
  'pricing.interval.period': '期間',
  'pricing.interval.week': '週',
  'pricing.interval.year': '年',
  'pricing.money_back': '30日間返金保証',
  'pricing.most_popular': '人気No.1',
  'pricing.no_prices': '料金がありません。',
  'pricing.plan_label.daily': '日次プラン',
  'pricing.plan_label.lifetime': '永久',
  'pricing.plan_label.monthly': '月間プラン',
  'pricing.plan_label.weekly': '週間プラン',
  'pricing.plan_label.yearly': '年間プラン',
  'pricing.plans_aria': 'プラン',
  'session.contact_support': 'サポートに連絡',
  'session.restore_purchases': '購入を復元',
  'session.sign_out': 'サインアウト',
  'session.signed_in_as_prefix': 'サインイン中:',
  'session.signing_out': 'サインアウト中…',
  'support.attachments_aria': '添付ファイルのアップロード',
  'support.attachments_label': '添付ファイル',
  'support.close_button': '閉じる',
  'support.done_button': '完了',
  'support.dropzone_text': '画像をここにドロップまたはクリックして選択',
  'support.email_placeholder': 'メールアドレスを入力',
  'support.file_requirements': 'JPEG/PNG/WebP、最大 {max} 個、各 {size}MB 以下',
  'support.heading': 'サポート',
  'support.instruction': 'サポートリクエストを送信するには、以下のフォームに記入してください。',
  'support.invalid_email': '無効なメールアドレス',
  'support.invalid_file': 'JPEG/PNG/WebPのみ、各{size}MB以下',
  'support.message_length': '1〜5000文字',
  'support.message_placeholder': 'メッセージを入力',
  'support.remove_file_aria': '{filename} を削除',
  'support.required': '必須',
  'support.send_another': '別のリクエストを送信',
  'support.send_button': '送信',
  'support.sending': '送信中…',
  'support.sending_as': '送信元:',
  'support.subject_length': '3〜200文字',
  'support.subject_placeholder': '件名を入力',
  'support.success_heading': 'リクエストを送信しました',
  'support.success_message_prefix': 'メッセージを受け取りました。返信先:',
  'support.too_many_files': '最大 {max} 個まで'
} as const;

export default ja;
